import { render, staticRenderFns } from "./VopProviderForm.vue?vue&type=template&id=4be01f31&"
import script from "./VopProviderForm.vue?vue&type=script&lang=js&"
export * from "./VopProviderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4be01f31')) {
      api.createRecord('4be01f31', component.options)
    } else {
      api.reload('4be01f31', component.options)
    }
    module.hot.accept("./VopProviderForm.vue?vue&type=template&id=4be01f31&", function () {
      api.rerender('4be01f31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/vopProvider/VopProviderForm.vue"
export default component.exports